import type { EventResetFilter, OrderSearch } from "orderManagement/models";

// The review queue's Event Reset filters, both Admin-only: the "Event Reset:" choices and the
// "Resettable:" checkbox.

// The Event Reset filter's choices, in menu order ("" = All).
export const EVENT_RESET_FILTERS: { value: EventResetFilter; label: string }[] = [
  { value: "NotReset", label: "Not reset" },
  { value: "Reset", label: "Reset" },
  { value: "ResetFailed", label: "Reset – auto-approve failed" },
  { value: "ResetApproved", label: "Reset – approved" },
];

// The two filters as saved in localStorage, back on the search. A value the menu no longer offers
// reads as All; both are Admin filters, so saved values are ignored for anyone else.
export const restoreEventResetFilters = (
  saved: any,
  canResetEvents: boolean
): Pick<OrderSearch, "eventResetFilter" | "isResettable"> => ({
  eventResetFilter: canResetEvents && EVENT_RESET_FILTERS.some((f) => f.value === saved?.eventResetFilter) ? saved.eventResetFilter : null,
  isResettable: canResetEvents && saved?.isResettable === true ? true : null,
});
